import { Component, Input, OnInit } from '@angular/core';

import { AppExpandTextClickShowEvent } from 'src/app/core/types/app-expand-text-click-show-event.type';
import { AppPlacement } from 'src/app/core/types/app-placement.type';

@Component({
    selector: 'app-expand-text',
    templateUrl: './expand-text.component.html',
    styleUrls: ['./expand-text.component.scss'],
    standalone: false
})
export class ExpandTextComponent implements OnInit {

  @Input() title: any;
  @Input() placement: AppPlacement = "left";
  @Input() showEvent: AppExpandTextClickShowEvent = "hover";

  fontClass: any;

  constructor() { }

  ngOnInit() {
    this.fontClass = "fas fa-chevron-" + this.placement;
  }

}
